import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { WHATSAPP_NUMBER, WH_LINK } from 'shared/constants'
import WaBanner from 'shared/images/wa-banner.webp'
import { openExternalUrl } from 'shared/lib/external-open'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Button } from 'shared/ui/button'
import { message } from 'shared/ui/message'

import styles from './styles.module.scss'

export const SupportBanner = () => {
  const { t } = useTranslation()

  const openSupportChat = () => {
    openExternalUrl(`${WH_LINK}${WHATSAPP_NUMBER}`, () => {
      message.error(t('support.whatsapp_open_error'))
    })
  }

  return (
    <section className={styles.banner}>
      <img
        aria-hidden="true"
        alt=""
        className={styles.background}
        src={WaBanner}
      />

      <div className={styles.content}>
        <h1 className={clsx('bold-22', styles.title)}>
          {t('support.need_help')}
        </h1>
        <p className={clsx('bold-16', styles.description)}>
          {t('support.chat_description')}
        </p>

        <Button
          className={styles.chatButton}
          type="button"
          variant="white"
          borderRadius="sm"
          onClick={openSupportChat}
        >
          <span className={styles.buttonContent}>
            <AppIcon
              id={AllIcons.WHATSAPP}
              width={24}
              height={24}
              color="var(--bright-green)"
            />
            <span className="bold-16">{t('support.open_chat')}</span>
            <AppIcon
              id={AllIcons.ARROW_RIGHT_LONG}
              width={24}
              height={24}
              color="var(--inverse)"
            />
          </span>
        </Button>
      </div>
    </section>
  )
}
